import { Col, Container, Row } from "react-bootstrap";
import { useIntl } from "react-intl";
import styles from "./styles/style.module.scss";
// Import Swiper
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
// Import Components
import Heading from "@/components/Shared/Heading/Heading";
import Card from "./Card";
// Import Images
import ArrowRightIcon from "@/assets/svgs/arrows/arrow-right-small.svg";
import ArrowLeftIcon from "@/assets/svgs/arrows/arrow-left-small.svg";

const Features = ({ data }) => {
  const { locale } = useIntl();
  return (
    <div className={`${styles["main-features"]} main-features`}>
      <Container>
        <Heading
          title={data?.title?.[locale]}
          subTitle={data?.subTitle?.[locale]}
          image={data?.backgroundImage}
        />
        <div className="cards-desktop">
          <Row>
            {data?.content?.items?.map((item, index) => (
              <Col xs={12} md={6} lg={6} xl={4} key={index}>
                <Card item={item} />
              </Col>
            ))}
          </Row>
        </div>
        <div className="cards-mobile">
          <div className="container-div">
            <Swiper
              modules={[Autoplay, Navigation]}
              className="mySwiper"
              loop={true}
              autoplay={{
                delay: 5000,
                disableOnInteraction: false,
              }}
              spaceBetween={30}
              slidesPerView={2}
              breakpoints={{
                0: {
                  slidesPerView: 1,
                  spaceBetween: 15,
                },
                768: {
                  slidesPerView: 2,
                  spaceBetween: 30,
                },
              }}
              navigation={{
                nextEl: ".swiper-button-next-why",
                prevEl: ".swiper-button-prev-why",
              }}
            >
              {data?.content?.items?.map((item) => (
                <SwiperSlide key={item.id}>
                  <Card item={item} />
                </SwiperSlide>
              ))}
            </Swiper>
            <div className="arrow-btns">
              <button
                aria-label="Next slide"
                className="swiper-button swiper-button-next-why"
                type="button"
              >
                <ArrowRightIcon fill="#444444" />
              </button>
              <button
                aria-label="Previous slide"
                type="button"
                className="swiper-button swiper-button-prev-why"
              >
                <ArrowLeftIcon fill="#444444" />
              </button>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Features;
